import {Button} from 'antd'
import openWindow from '@/script/openWindow.mjs'
import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

const PropertiesPaneButtonCode = (props) => {
    const [values] = useProperties()
    const {pkid, vmUserCode, vmName} = values

    if (! pkid) {
        return null
    }

    const handleClick = e => {
        openWindow(
            '/vmIDE',
            {vmId: pkid, vmName, vmUserCode},
            e.altKey ? '_self' : '_blank'
        )
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >查看代码</Button>
    )
}

export default PropertiesPaneButtonCode
